import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '../mock';
import { Calendar, Clock, Tag } from 'lucide-react';

const Blog = () => {
  const [selectedTag, setSelectedTag] = useState(null);

  const allTags = [...new Set(articles.flatMap(a => a.tags))];
  
  const filteredArticles = selectedTag 
    ? articles.filter(a => a.tags.includes(selectedTag))
    : articles;

  return (
    <div className="page-container blog-page">
      <div className="page-header">
        <h1 className="page-title">
          <span className="text-amber">[</span>
          BLOG_&_ARTICLES
          <span className="text-amber">]</span>
        </h1>
        <div className="ascii-line">
          {'━'.repeat(60)}
        </div>
        <p className="page-subtitle text-muted">
          # Technical articles and security research
        </p>
      </div>

      <div className="blog-content">
        <pre className="command-output">
{`$ tail -f /var/log/articles.log
Monitoring articles feed...
`}
        </pre>

        <div className="tag-filter">
          <div className="filter-label">
            <Tag size={16} />
            <span>Filter by tag:</span>
          </div>
          <div className="tag-buttons">
            <button 
              className={`tag-button ${!selectedTag ? 'active' : ''}`}
              onClick={() => setSelectedTag(null)}
            >
              ALL
            </button>
            {allTags.map(tag => (
              <button 
                key={tag}
                className={`tag-button ${selectedTag === tag ? 'active' : ''}`}
                onClick={() => setSelectedTag(tag)}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="articles-list">
          {filteredArticles.map((article) => (
            <article key={article.id} className="article-card">
              <div className="article-header">
                <h2 className="article-title">
                  <span className="text-cyan">&gt;</span> {article.title}
                </h2>
                <div className="article-meta">
                  <span className="meta-item">
                    <Calendar size={14} />
                    {article.date}
                  </span>
                  <span className="meta-item">
                    <Clock size={14} />
                    {article.readTime}
                  </span>
                </div>
              </div>

              <p className="article-excerpt">
                {article.excerpt}
              </p>

              <div className="article-footer">
                <div className="article-tags">
                  {article.tags.map((tag, index) => (
                    <span key={index} className="article-tag">
                      <span className="text-purple">#</span>{tag}
                    </span>
                  ))}
                </div>
                <Link to={`/blog/${article.id}`} className="read-more-button">
                  Read More →
                </Link>
              </div>

              <div className="article-divider">
                {'─'.repeat(70)}
              </div>
            </article>
          ))}
        </div>

      </div>

      <div className="terminal-hint-bottom">
        <span className="text-muted">
          # Terminal command: type 'cat articles' to list all articles
        </span>
      </div>
    </div>
  );
};

export default Blog;